import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { pageData } from 'decorators'
import { Row, Col, Table } from 'reactstrap'
import { Text, TableHeader, TableCell, MinutesTableCell } from 'components'
import PHASE from 'utils/constants/phases'
import { priceFormatted } from 'utils/string'
import { sortBy } from 'lodash'
import { translate } from 'react-i18next'
import { Phase } from '../Phase'
import './PostSeason.css'

@pageData({ title: 'PostSeason' })
@connect(
    state => ({
        phase: state.phaseInfo.phase,
        postSeasonData: state.phaseInfo.data,
        season: state.phaseInfo.season
    }),
    null
)
@translate()
export class PostSeason extends PureComponent {
    renderRowPlayerByPoints = ({ position, name, totalPoints, totalTime }, index) => (
        <tr key={index}>
            <TableCell tag="td" className="Big text-center">{position}</TableCell>
            <TableCell tag="td" className="text-center">{name}</TableCell>
            <TableCell tag="td" className="text-center">{totalPoints}</TableCell>
            <MinutesTableCell tag="td" className="text-center">{totalTime}</MinutesTableCell>
        </tr>
    )
    renderRowPlayerByProfitability = ({ position, name, profitability, credits }, index) => (
        <tr key={index}>
            <TableCell tag="td" className="Big text-center">{position}</TableCell>
            <TableCell tag="td" className="text-center">{name}</TableCell>
            <TableCell tag="td" className="text-center">{Number(Number(profitability) || 0).toFixed(4)}</TableCell>
            <TableCell tag="td" className="text-center">{priceFormatted(credits)}</TableCell>
        </tr>
    )
    render() {
        const { phase, postSeasonData, season, t } = this.props
        const { byPoints = [], byProfitability = [] } = postSeasonData || {}
        return phase === PHASE.POST_SEASON && (
            <Phase
                className="PostSeason"
                showEndPhaseBtn
                interTitles={[
                    {
                        image: 'finish',
                        title: t('game.POST_SEASON.interTitle.title', { season })
                    }
                ]}
            >
                <section className="Content">
                    <Row className="h-100">
                        <Col xs={12} sm={6} className="h-100">
                            <div className="h-100 flex col-stretch">
                                <Text>{t('game.POST_SEASON.byTotalPoints')}</Text>
                                <div className="TableCard">
                                    <Table className="vertical-center">
                                        <thead>
                                            <tr>
                                                <TableHeader tag="th" className="text-center">{t('game.POST_SEASON.tableHeaders.position')}</TableHeader>
                                                <TableHeader tag="th" className="text-center">{t('game.POST_SEASON.tableHeaders.player')}</TableHeader>
                                                <TableHeader tag="th" className="text-center">{t('game.POST_SEASON.tableHeaders.totalPoints')}</TableHeader>
                                                <TableHeader tag="th" className="text-center">{t('game.POST_SEASON.tableHeaders.totalTime')}</TableHeader>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sortBy(byPoints, 'position').map(this.renderRowPlayerByPoints)}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12} sm={6} className="h-100">
                            <div className="h-100 flex col-stretch">
                                <Text>{t('game.POST_SEASON.byProfitability')}</Text>
                                <div className="TableCard">
                                    <Table className="vertical-center">
                                        <thead>
                                            <tr>
                                                <TableHeader tag="th" className="text-center">{t('game.POST_SEASON.tableHeaders.position')}</TableHeader>
                                                <TableHeader tag="th" className="text-center">{t('game.POST_SEASON.tableHeaders.player')}</TableHeader>
                                                <TableHeader tag="th" className="text-center">{t('game.POST_SEASON.tableHeaders.profitability')}</TableHeader>
                                                <TableHeader tag="th" className="text-center">{t('game.POST_SEASON.tableHeaders.credits')}</TableHeader>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sortBy(byProfitability, 'position').map(this.renderRowPlayerByProfitability)}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </section>
            </Phase>
        )
    }
}



// WEBPACK FOOTER //
// src/pages/Phases/PostSeason/PostSeason.js